/**
 * Client-side percentile lookup against the shipped quantile curve.
 *
 * The backend ships, per cell and for the ACTIVE spread type only, 21 points of
 * the daily distribution: p0, p5, ... p100. Every colour-bucket boundary
 * (p10, p20 ... p90) is one of them, so the bucket — and therefore the cell
 * colour — is decided exactly; only the printed percentage is interpolated.
 *
 * This is what lets a live price recolour the grid without asking the server.
 */

/** Percentile step between consecutive points. */
const STEP = 5;

/**
 * Percentile (0-100) of `value` within the ascending curve.
 *
 * Weak definition — count(x <= value)/n — matching the exact ClickHouse countIf
 * this replaces. Guard order matters: a completely flat series (a stale or
 * non-trading pair, where curve[0] === curve[last]) must report 100, not 0.
 */
export function percentileFromCurve(value, curve) {
  if (value == null || !curve || curve.length < 2) return null;
  const n = curve.length;
  if (value >= curve[n - 1]) return 100;
  if (value < curve[0]) return 0;

  let lo = 0, hi = n - 1;
  while (hi - lo > 1) {
    const mid = (lo + hi) >> 1;
    if (curve[mid] <= value) lo = mid; else hi = mid;
  }
  const span = curve[hi] - curve[lo];
  const frac = span === 0 ? 0 : (value - curve[lo]) / span;
  return (lo + frac) * STEP;
}

/** Alias kept for call sites that used the packed form. */
export const percentileFromPacked = percentileFromCurve;
